import { ErrorState } from '../../feedback/ErrorState';
import { useMyProjectFeedbacks } from '../../../hooks/useProjectFeedback.js';
import { FeedbackList } from './FeedbackList.js';

/**
 * マイページの案件 FB タブ。自分の FB を新しい順に並べ、詳細へ遷移する。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering, HR
 * @graph-business My page tab listing the signed-in engineer's own project feedback (project, kind, generated date, open objections) with links to the detail
 * @graph-connects useMyProjectFeedbacks [calls] 自分の FB 一覧
 * @graph-connects FeedbackList [calls] 一覧の表示
 */
export function MyFeedbackTab() {
  const { data, isLoading, isError, refetch } = useMyProjectFeedbacks();

  if (isLoading) {
    return <div className="h-24 animate-pulse rounded bg-[var(--color-bg-elevated)]" />;
  }
  if (isError) {
    return (
      <ErrorState
        onRetry={() => {
          void refetch();
        }}
      />
    );
  }
  return <FeedbackList feedbacks={data?.feedbacks ?? []} emptyText="案件 FB はまだありません" />;
}
